import ReportStudySetup1 from './reportStudySetup1'
export default ReportStudySetup1
